import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { useTheme } from '../contexts/ThemeContext';
import { useHeaderScroll } from '../contexts/HeaderScrollContext';
import { shouldShowBack, goBack } from '../utils/pageBack';

/**
 * @param {'storefront' | 'headerless'} variant
 * - storefront: fixed back only when navbar is hidden on scroll
 * - headerless: always fixed (cart, checkout)
 */
export default function PageBackButton({ variant = 'headerless' }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isDark } = useTheme();
  const { isHeaderVisible } = useHeaderScroll();

  if (!shouldShowBack(pathname)) return null;

  const showFixed =
    variant === 'headerless' || (variant === 'storefront' && !isHeaderVisible);

  if (!showFixed) return null;

  const chromeClass = isDark
    ? 'border-slate-600 bg-slate-800/95 text-slate-100 hover:bg-slate-700'
    : 'border-gray-200 bg-white/95 text-gray-700 hover:bg-gray-50';

  return (
    <button
      type="button"
      onClick={() => goBack(navigate)}
      aria-label="Go back"
      className={`fixed z-[90] flex h-10 w-10 items-center justify-center rounded-full border shadow-lg backdrop-blur-sm transition-all duration-200 top-[max(0.75rem,env(safe-area-inset-top))] left-[max(0.75rem,env(safe-area-inset-left))] ${chromeClass}`}
    >
      <FaArrowLeft className="text-sm" />
    </button>
  );
}
